<template>
  <div>
    <BaseInput
      v-mask="'####-##-##'"
      :label="label"
      :value="textValue"
      :disabled="disabled"
      :no-margin="noMargin"
      :validate="computedValidate"
      @input="v => fromText(v)"
      @focus="openPicker"
      @blur="closePicker">
      <div
        slot="input-group-prepend"
        class="input-group-prepend">
        <button
          type="button"
          class="btn btn-light"
          @click="openPicker"
          @blur="closePicker">
          <IconCalendar />
        </button>
      </div>
    </BaseInput>
    <Datepicker
      ref="datepicker"
      :language="language"
      :disabled-dates="disabledDates"
      :value="value"
      :inline="false"
      format="yyyy-MM-dd"
      bootstrap-styling
      wrapper-class="datepicker-wrapper"
      input-class="d-none"
      @selected="v => fromDate(v)" />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { en, fr } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

export default {
  components: {
    Datepicker,
  },
  props: {
    value: {
      type: [Date, String],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: String,
      default: '',
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const self = this;

    return {
      disabledDates: {
        customPredictor(date) {
          const mDate = moment(date);

          let disabled = false;
          if (self.minDate) {
            const minDate = moment(self.minDate);
            if (mDate.isBefore(minDate, 'day')) {
              disabled = true;
            }
          }

          if (self.maxDate) {
            const maxDate = moment(self.maxDate);
            if (mDate.isAfter(maxDate, 'day')) {
              disabled = true;
            }
          }

          return disabled;
        },
      },
    };
  },
  computed: {
    textValue() {
      if (this.value instanceof Date) {
        return moment(this.value).format('YYYY-MM-DD');
      }
      return this.value;
    },
    language() {
      switch (this.$i18n.locale) {
        case 'fr':
          return fr;
        default:
          return en;
      }
    },
    computedValidate() {
      if (this.validate) {
        return `${this.validate}|date_format:YYYY-MM-DD`;
      }
      return 'date_format:YYYY-MM-DD';
    },
  },
  methods: {
    openPicker() {
      this.$refs.datepicker.showCalendar();
    },
    closePicker() {
      this.$refs.datepicker.close();
    },
    fromText(text) {
      const date = moment(text, 'YYYY-MM-DD', true);
      if (date.isValid()) {
        this.$emit('input', date.toDate());
      } else {
        this.$emit('input', text);
      }
    },
    fromDate(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.datepicker-wrapper {
  position: relative;
  top: -$form-group-margin-bottom;
}
</style>
